__turbopack_context__.v({
  "content-spacing": "what-you-will-learn-module-scss-module__BBo-EG__content-spacing",
  "objective-item": "what-you-will-learn-module-scss-module__BBo-EG__objective-item",
  "objectives-list": "what-you-will-learn-module-scss-module__BBo-EG__objectives-list",
  "objectives-list-two-column-layout": "what-you-will-learn-module-scss-module__BBo-EG__objectives-list-two-column-layout",
  "title": "what-you-will-learn-module-scss-module__BBo-EG__title",
  "what-you-will-learn": "what-you-will-learn-module-scss-module__BBo-EG__what-you-will-learn",
});
